import { ShopperAgentAggregateInsightKind } from "@redotech/cockroachdb-codegen/tables/shopper-ai/shopper-agent-aggregate-insight-kind";
import { Schema } from "effect";
import {
  ChannelThreadId,
  MessageId,
  ShopperAgentAggregateInsightRunId,
  TopicId,
} from "../../../ids/definitions";
import { Message } from "./message";

export const ShopperAgentAggregateInsightType = Schema.Enums(
  ShopperAgentAggregateInsightKind,
);
export type ShopperAgentAggregateInsightType =
  typeof ShopperAgentAggregateInsightType.Type;

export const ShopperAgentAggregateInsightSummary = Schema.Struct({
  topicId: TopicId,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
});
export type ShopperAgentAggregateInsightSummary =
  typeof ShopperAgentAggregateInsightSummary.Type;

export const ShopperAgentAggregateInsightRunSummary = Schema.Struct({
  id: ShopperAgentAggregateInsightRunId,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  insights: Schema.Array(ShopperAgentAggregateInsightSummary),
});
export type ShopperAgentAggregateInsightRunSummary =
  typeof ShopperAgentAggregateInsightRunSummary.Type;

export const ShopperAgentAggregateInsightRunListResponse = Schema.Struct({
  runs: Schema.Array(ShopperAgentAggregateInsightRunSummary),
});
export type ShopperAgentAggregateInsightRunListResponse =
  typeof ShopperAgentAggregateInsightRunListResponse.Type;

export const ShopperAgentAggregateInsightEvidenceSpan = Schema.Struct({
  startMessageId: MessageId,
  endMessageId: MessageId,
  messages: Schema.Array(Message),
});
export type ShopperAgentAggregateInsightEvidenceSpan =
  typeof ShopperAgentAggregateInsightEvidenceSpan.Type;

export const ShopperAgentAggregateInsightEvidenceConversation = Schema.Struct({
  conversationTopicId: TopicId,
  channelThreadId: ChannelThreadId,
  spans: Schema.Array(ShopperAgentAggregateInsightEvidenceSpan),
});
export type ShopperAgentAggregateInsightEvidenceConversation =
  typeof ShopperAgentAggregateInsightEvidenceConversation.Type;

export const ShopperAgentAggregateInsightDailyCount = Schema.Struct({
  date: Schema.String,
  count: Schema.Number,
});
export type ShopperAgentAggregateInsightDailyCount =
  typeof ShopperAgentAggregateInsightDailyCount.Type;

export const ShopperAgentAggregateInsightFaqDetailData = Schema.Struct({
  type: Schema.Literal(ShopperAgentAggregateInsightKind.Faq),
  conversationCount: Schema.Number,
  dailyTrend: Schema.Array(ShopperAgentAggregateInsightDailyCount),
});
export type ShopperAgentAggregateInsightFaqDetailData =
  typeof ShopperAgentAggregateInsightFaqDetailData.Type;

export const ShopperAgentAggregateInsightSentimentDistribution = Schema.Struct({
  positive: Schema.Number,
  neutral: Schema.Number,
  mixed: Schema.Number,
  negative: Schema.Number,
});
export type ShopperAgentAggregateInsightSentimentDistribution =
  typeof ShopperAgentAggregateInsightSentimentDistribution.Type;

export const ShopperAgentAggregateInsightSentimentDailyCount = Schema.Struct({
  date: Schema.String,
  positive: Schema.Number,
  neutral: Schema.Number,
  mixed: Schema.Number,
  negative: Schema.Number,
});
export type ShopperAgentAggregateInsightSentimentDailyCount =
  typeof ShopperAgentAggregateInsightSentimentDailyCount.Type;

export const ShopperAgentAggregateInsightSentimentDetailData = Schema.Struct({
  type: Schema.Literal(ShopperAgentAggregateInsightKind.Sentiment),
  conversationCount: Schema.Number,
  distribution: ShopperAgentAggregateInsightSentimentDistribution,
  dailyTrend: Schema.Array(ShopperAgentAggregateInsightSentimentDailyCount),
});
export type ShopperAgentAggregateInsightSentimentDetailData =
  typeof ShopperAgentAggregateInsightSentimentDetailData.Type;

export const ShopperAgentAggregateInsightEscalationDetailData = Schema.Struct({
  type: Schema.Literal(ShopperAgentAggregateInsightKind.Escalation),
});
export type ShopperAgentAggregateInsightEscalationDetailData =
  typeof ShopperAgentAggregateInsightEscalationDetailData.Type;

export const ShopperAgentAggregateInsightDetailData = Schema.Union(
  ShopperAgentAggregateInsightFaqDetailData,
  ShopperAgentAggregateInsightSentimentDetailData,
  ShopperAgentAggregateInsightEscalationDetailData,
);
export type ShopperAgentAggregateInsightDetailData =
  typeof ShopperAgentAggregateInsightDetailData.Type;

export const ShopperAgentAggregateInsightDetailResponse = Schema.Struct({
  topicId: TopicId,
  runId: ShopperAgentAggregateInsightRunId,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
  description: Schema.String,
  evidenceConversations: Schema.Array(
    ShopperAgentAggregateInsightEvidenceConversation,
  ),
  detailData: ShopperAgentAggregateInsightDetailData,
});
export type ShopperAgentAggregateInsightDetailResponse =
  typeof ShopperAgentAggregateInsightDetailResponse.Type;

export const RelatedShopperAgentAggregateInsightSpan = Schema.Struct({
  startMessageId: MessageId,
  endMessageId: MessageId,
});
export type RelatedShopperAgentAggregateInsightSpan =
  typeof RelatedShopperAgentAggregateInsightSpan.Type;

export const RelatedShopperAgentAggregateInsight = Schema.Struct({
  topicId: TopicId,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  spans: Schema.Array(RelatedShopperAgentAggregateInsightSpan),
});
export type RelatedShopperAgentAggregateInsight =
  typeof RelatedShopperAgentAggregateInsight.Type;
